import { MediaState } from '../domain/media-file.types';
import { MediaEvent } from '../media.events';
import { filesInitReducer } from './files-init';
import { filesStatusReducer } from './files-status';
import { videoFilesReducer } from './video-files';

export const mediaReducer = (
  state: MediaState,
  event: MediaEvent
): MediaState => {
  return [filesInitReducer, filesStatusReducer, videoFilesReducer].reduce(
    (acc, reducer) => reducer(acc, event),
    state
  );
};
